import React from "react";
import { Checkbox } from "@heroui/react";

export function PortalCheckbox({ isSelected, onChange, children, isDisabled, className, ...props }) {
  return (
    <Checkbox
      isSelected={isSelected}
      onChange={onChange}
      isDisabled={isDisabled}
      className={className}
      {...props}
    >
      <Checkbox.Content>
        <Checkbox.Control>
          <Checkbox.Indicator />
        </Checkbox.Control>
        {children}
      </Checkbox.Content>
    </Checkbox>
  );
}
